import styled from 'styled-components';
import { themeList } from '../../contexts/ThemeContext/themeList';

export const FooterStyled = styled.footer`
  border-top: '#c90808';
  background-color: '#c90808';
  padding-top: 10px;
  h4 {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme: { theme } }) =>
      theme === themeList.dark ? 'var(--ds-light-0)' : 'var(--ds-dark-1)'};
  }
`;

export const FooterSquareStyled = styled.div`
  border-top: '#c90808';
  text-align: center;
  padding: 30px;
  border-top: '#c90808';
  background-color: '#c90808';
  h3 {
    font-size: 40px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${({ theme: { theme } }) =>
      theme === themeList.dark ? 'var(--ds-light-0)' : 'var(--ds-dark-3)'};
  }
  p {
    margin: 0;
    font-size: 15px;
  }
  ul {
    width: 100px;
    margin: auto;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    li {
      transition: all 0.3s;
      border-radius: 100%;
      cursor: pointer;
      padding: 11px 12px;
      line-height: 5px;

      margin-inline: 3px;
      background-color: '#c90808';
      &:hover {
        background-color: var(--ds-blood);
        svg {
          color: var(--ds-light-0);
        }
      }
      svg {
        font-size: 20px;
      }
    }
  }
`;

export const FooterListLinksStyled = styled.div`
  background-color: '#c90808';
  text-align: center;
  padding: 30px;
  border-top: '#c90808';
  @media (max-width: 991px) {
    margin: 20px 0;
  }
  ul {
    li {
      transition: all 0.5s;
      font-size: 14px;
      font-weight: 500;
      margin: 10px 0;
      cursor: pointer;
      &:hover {
        color: var(--ds-blood);
      }
      svg {
        font-size: 20px;
        color: var(--ds-blood);
      }
    }
  }
`;

export const FooterNewsLetterStyled = styled.div`
  border-top: '#c90808';
  p {
    font-size: 16px;
    font-style: italic;
    letter-spacing: -1px;
  }
  .subscribe-form {
    display: flex;
    input {
      border-radius: 0;
      width: 70%;
      &:focus {
        box-shadow: none;
      }
    }
    button {
      width: 30%;
      padding: 10px;
    }
  }
  .social-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .social-icons svg {
    margin: 0 10px;
    font-size: 2em;
  }
  .subscribe-form {
    display: flex;
    align-items: center;
    margin-top: 20px;
    color: white;
  }

  .subscribe-form input {
    margin-right: 10px;
  }

  .social-icons {
    margin-bottom: 10px; /* Add some margin at the bottom */
  }

  .newsletter-section {
    margin-top: 50px; /* Add some margin at the top */
  }
  .newsletter {
    margin-top: 20px; /* Add some margin at the top */
  }
`;
